module.exports = __webpack_public_path__ + "static/media/industry_hover3.369c2206.svg";